import { createContext, useState, useEffect, useCallback, useMemo } from "react";
import api from "../api/axios";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState({
    id: "",
    name: "",
    email: "",
    phone: "",
    kycStatus: "",
    role: "user",
  });

  const [wallet, setWallet] = useState({
    balance: 0,
    deposits: 0,
    withdrawals: 0,
  });

  /* const [crypto, setCrypto] = useState({
    balances: {},
    transactions: [],
  }); */

  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("token");

  const refreshUserData = useCallback(async () => {
    const currentToken = localStorage.getItem("token");
    if (!currentToken) {
      setLoading(false);
      return;
    }

    try {
      const [profileResponse, dashboardResponse, transactionsResponse] = await Promise.all([
        api.get("/profile"),
        api.get("/user/dashboard"),
        api.get("/transactions"),
      ]);

      const profileData = profileResponse.data;

      setUser({
        id: profileData._id || profileData.id || "",
        name: profileData.fullName,
        email: profileData.email,
        phone: profileData.phone,
        kycStatus: profileData.kycStatus || "",
        role: profileData.role || "user",
      });

      // === Fetch Wallet + Crypto Dashboard Data ===
      const dashboardData = dashboardResponse.data;

      const walletData = dashboardData.wallet || {};
      // const cryptoData = dashboardData.crypto || {};

      setWallet({
        balance: walletData.balance || 0,
        deposits: walletData.deposits || 0,
        withdrawals: walletData.withdrawals || 0,
      });

      const fetchedTransactions = Array.isArray(transactionsResponse.data)
        ? transactionsResponse.data
        : Array.isArray(transactionsResponse.data?.transactions)
        ? transactionsResponse.data.transactions
        : walletData.transactions || [];

      setTransactions(fetchedTransactions.filter((transaction) => !transaction.type?.startsWith("crypto_")));
      /* setCrypto({
        balances: cryptoData.balances || {},
        transactions: cryptoData.transactions || [],
      }); */

    } catch (err) {
      console.error("Error fetching user data:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!token) {
      setLoading(false);
      return;
    }
    refreshUserData();
  }, [token, refreshUserData]);

  // === Helper functions (stable refs for consumer effects) ===
  const updateUser = useCallback((updatedFields) => {
    setUser((prev) => ({ ...prev, ...updatedFields }));
  }, []);

  const updateWallet = useCallback((updatedFields) => {
    setWallet((prev) => ({ ...prev, ...updatedFields }));
  }, []);

  /* const updateCrypto = useCallback((updatedFields) => {
    setCrypto((prev) => ({ ...prev, ...updatedFields }));
  }, []); */

  const updateTransactions = useCallback((newTransactions) => {
    setTransactions(newTransactions);
  }, []);

  const contextValue = useMemo(() => ({
    user,
    setUser: updateUser,
    wallet,
    setWallet: updateWallet,
    // crypto,
    // setCrypto: updateCrypto,
    transactions,
    setTransactions: updateTransactions,
    loading,
    refreshUserData,
  }), [
    user,
    updateUser,
    wallet,
    updateWallet,
    // crypto,
    // updateCrypto,
    transactions,
    updateTransactions,
    loading,
    refreshUserData,
  ]);

  return (
    <UserContext.Provider value={contextValue}>
      {children}
    </UserContext.Provider>
  );
};
